import { create } from 'zustand';

export type ReportInfo = {
  isWaiting: boolean;
  name: string;
  id: string;
};

interface WaitingReportStoreState {
  reportInfo: ReportInfo[] | null;
  reportError: boolean;
}

interface WaitingReportStoreActions {
  setReportInfo: (reportInfo: ReportInfo[] | null) => void;
  setReportError: (reportError: boolean) => void;
}

interface WaitingReportStore {
  state: WaitingReportStoreState;
  actions: WaitingReportStoreActions;
}

export const useWaitingReportStore = create<WaitingReportStore>(set => ({
  state: {
    reportInfo: null,
    reportError: false,
  },
  actions: {
    setReportInfo: reportInfo =>
      set(state => ({
        state: {
          ...state.state,
          reportInfo,
        },
      })),
    setReportError: reportError =>
      set(state => ({
        state: {
          ...state.state,
          reportError,
        },
      })),
  },
}));
